import { isNumericId, isVimeoCdnUrl } from '../utils/safe-url.js';

const MAX_TITLE_CHARS = 120;
const HI_RES = '_1600x900';

async function fetchOEmbed(id) {
  const url = `https://vimeo.com/api/oembed.json?url=https%3A%2F%2Fvimeo.com%2F${id}&width=1600`;
  const res = await fetch(url, { credentials: 'omit', referrerPolicy: 'no-referrer' });
  if (!res.ok) throw new Error(`oembed ${res.status}`);
  return res.json();
}

function swapImage(img, candidate, fallback) {
  const safe = isVimeoCdnUrl(candidate) ? candidate : fallback;
  const preload = new Image();
  preload.onload = () => { img.src = safe; };
  preload.onerror = () => { img.src = fallback; };
  preload.src = safe;
}

async function hydrateCard(card) {
  const id = card.getAttribute('data-vimeo');
  if (!isNumericId(id)) return;
  const img = card.querySelector('.thumb');
  if (!img) return;
  try {
    const data = await fetchOEmbed(id);
    if (data.thumbnail_url && isVimeoCdnUrl(data.thumbnail_url)) {
      const hi = data.thumbnail_url.replace(/_\d+x\d+/, HI_RES);
      swapImage(img, hi, data.thumbnail_url);
    }
    if (typeof data.title === 'string') {
      const titleEl = card.querySelector('h3');
      if (titleEl) titleEl.textContent = data.title.slice(0, MAX_TITLE_CHARS);
    }
  } catch {
    /* keep fallback img */
  }
}

export function initVimeoThumbs() {
  document.querySelectorAll('.video-card').forEach(hydrateCard);
}
